var _ellipse, _path, _ellipse2, _path2, _ellipse3, _ellipse4, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52,
    cy: 11.667,
    rx: 2,
    ry: 2,
    stroke: "#fff",
    strokeWidth: "2px",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.3346 11.7876C57.3346 15.4913 52.0013 19.6663 52.0013 19.6663C52.0013 19.6663 46.668 15.4913 46.668 11.7876C46.668 8.21853 49.4915 6.33301 52.0013 6.33301C54.5111 6.33301 57.3346 8.08385 57.3346 11.7876Z",
    stroke: "#fff",
    strokeWidth: "2px",
    strokeLinejoin: "round",
    fill: "none"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 41.333,
    rx: 2.5,
    ry: 2.5,
    stroke: "#fff",
    strokeWidth: "2px",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6654 41.4852C18.6654 46.1148 11.9987 51.3337 11.9987 51.3337C11.9987 51.3337 5.33203 46.1148 5.33203 41.4852C5.33203 37.0239 8.86144 34.667 11.9987 34.667C15.136 34.667 18.6654 36.8555 18.6654 41.4852Z",
    stroke: "#fff",
    strokeWidth: "2px",
    strokeLinejoin: "round",
    fill: "none"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 57,
    rx: 2,
    ry: 2,
    stroke: "#fff",
    strokeWidth: "2px",
    fill: "none"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52,
    cy: 25,
    rx: 2,
    ry: 2,
    stroke: "#fff",
    strokeWidth: "2px",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52 25H30C25.5817 25 22 28.5817 22 33V33C22 37.4183 25.5817 41 30 41H43",
    stroke: "#fff",
    strokeWidth: "2px",
    strokeLinecap: "round",
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 57L44 57C48.4183 57 52 53.4183 52 49V49C52 44.5817 48.4183 41 44 41L31 41",
    stroke: "#fff",
    strokeWidth: "2px",
    strokeLinecap: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.783f9ddc937239c0afdb956eb3e06542.svg";
export { ForwardRef as ReactComponent };